import { Pipe, PipeTransform } from '@angular/core';
import { NestedHelpersService } from '../../service/nested-helpers.service';
import { NestedDirective } from '../../component/nested.directive';

@Pipe({
    name: 'hasNested'
})
export class HasNestedPipe implements PipeTransform {

    constructor(private nestedHelpersService: NestedHelpersService) {}

    transform(value?: NestedDirective[], tag?: string): boolean {
        return this.nestedHelpersService.filter(value, tag).length > 0;
    }
}
